(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {

        module.exports = definition();

    } else {

        RivalIQ.module('enums');
        RivalIQ.enums.facebookAdSetDeliveryStatuses = definition();

    }

    function definition() {

        return {
            ACTIVE: {
                id: 'ACTIVE',
                name: 'Active',
                deliveryInfos: ['active']
            },

            DELETED: {
                id: 'DELETED',
                name: 'Deleted',
                deliveryInfos: ['deleted']
            },

            ERRORS: {
                id: 'ERRORS',
                name: 'Errors',
                deliveryInfos: ['errors']
            },
            INACTIVE: {
                id: 'INACTIVE',
                name: 'Inactive',
                deliveryInfos: ['inactive']
            },
            OFF: {
                id: 'OFF',
                name: 'Off',
                deliveryInfos: ['off']
            },
            PENDING: {
                id: 'PENDING',
                name: 'Pending',
                deliveryInfos: ['pending']
            }
        };
    }
})();
